import React from "react";
import { history, onLogout, removeUserToken, setUserToken } from "helpers";
import { toast } from "react-toastify";
import { ToasterChild } from "component/Common/ToasterContainer";
import { useSelector } from "react-redux";

export const baseUrl = process.env.REACT_APP_BASE_URL;
export const openUrl = process.env.REACT_APP_OPEN_URL;

export const apiMethods = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
};

export const responseHandler = (response, showToast = true, showLoader) => {
  let msg;

  if (response.status === 200) {
    msg = response.data?.message || response.message;
    if (showToast || !response.data.success) {
      toast(<ToasterChild success={!!response.data.success} message={msg} />);
    }
  } else {
    msg = response.data.message;
    toast(<ToasterChild success={false} message={msg} />);
  }

  const finalResp = {
    ...response.data,
    data: response?.data?.data || null,
    success: response.data.success,
    message: msg,
    setLoader: showLoader,
  };

  return finalResp;
};

export const axiosErrorHandler = (error, showToast = true, redirectUrl = null) => {
  let msg = "";
  let shown = false;
  msg = error?.response?.data?.message || error.message;
  localStorage.getItem("user_token");

  const invalidAuthorised =
    error?.response?.data?.status === 401 ||
    error?.response?.status === 401 ||
    error?.request?.status === 401;

  if (
    error.message !== "componentunmounted" &&
    msg &&
    localStorage.getItem("user_token") &&
    !invalidAuthorised &&
    error?.response?.data?.subscription_status !== "INACTIVE" &&
    showToast
  ) {
    console.log("showing toast");
    toast(<ToasterChild success={false} message={msg} />, {
      toastId: "session_expired",
    });
    shown = true;
  }

  if (invalidAuthorised) {
    onLogout();
    // localStorage.clear();

    if (!shown) {
      toast(<ToasterChild success={false} message={msg} tosd />, {
        toastId: "session_expired",
      });
    }
    if (redirectUrl) {
      history.push(`/auth/login?redirect=${encodeURIComponent(redirectUrl)}`);
    } else {
      history.push(`/auth/login`);
    }
  }

  const errorResp = {
    err: error?.response,
    success: error?.response?.data?.success,
    data: null,
    message: msg,
  };
  return errorResp;
};

export const endPoints = {
  auth: {
    SEND_OTP: `${baseUrl}/auth/send_otp`,
    VERIFY_OTP: `${baseUrl}/auth/verify_otp`,
    RESEND_OTP: `${baseUrl}/auth/resend_otp`,
    SIGNUP: `${baseUrl}/auth/signup`,
    LOGOUT: `${baseUrl}/auth/logout`,
    SIGNUP_DETAILS: `${baseUrl}/auth/signup_details`,
    SEND_EMAIL_OTP: `/email/send_otp`,
    RESEND_EMAIL_OTP: `/email/resend_otp`,
    VERIFY_EMAIL_OTP: `/email/verify_otp`,
  },
  fairUse: {
    ADD_DEVICE: "/auth/add_device",
    LIST_DEVICES: "/user_devices",
  },
  allotment: {
    GET_ALL_ALLOTMENTS: `/allotments/table_data`,
    GET_CLOSING_RANKS: `/allotments/closing_ranks`,
    cousellingsList: "/allotments/counsellings",
    filterdata: "/allotments/filter_data",
  },
  closingRank: {
    GET_FILTER_DATA: "/closing_ranks/filter_data",
    GET_CLOSING_RANKS: "/closing_ranks/table_data",
    GET_ALL_ALLOTMENTS: "/closing_ranks/allotments_table_data",
    instituteFilterData: "/closing_ranks/institute_filter_data",
    instituteTableData: "/closing_ranks/institute_table_data",
  },
  user: {
    GET_META: `/user/meta`,
    SWITCH_EXAM: `/user/switch_exam`,
    GET_PROFILE: `/user`,
    POST_PROFILE: `/user/update_details`,
    PACKAGES: "/user/packages",
    USER_FILTERS: "/user_filters",
    NOTIFICATION: "/user/notifications",
    RESEND_EMAIL_VERIFICATION: `${baseUrl}/user/resend_email_verification`,
    PINNED_COUNSELLINGS: `/user/pinned_counsellings`,
  },
  dashboard: {
    GET_GLOBAL_SEARCH: "/search",
    GET_ARTICLES: `/info/articles`,
    GET_SOCIAL_MEDIA: "/info/media_updates",
    GET_DASHBOARD_FEATURES: "/communique",
    GET_NERD_UPDATES: "/communique/nerd_updates",
    GET_BULLETINS: "/info/bulletins",
    GET_COUNSELLING_TIMELINE: "/info/counselling_timeline",
    GET_FILTER_DATA: "/info/filter_data",
    MARK_POPUP_AS_VIEWED: "/info/mark_popup_as_viewed",
  },
  counsellingDashboard: {
    COUNSELLING_TIMELINE: "/counsellings/timeline",
    PIN_COUNSELLING: "/user/pin_counselling",
    UNPIN_COUNSELLING: "/user/unpin_counselling",
  },
  communique: {
    DASHBOARD_FEATURES: "/communique",
    ANNOUNCEMENTS_AND_EVENTS_SNAPSHOT: "/communique/snapshot",
    ANNOUNCEMENTS: "/communique/announcements",
    COUNSELLINGS: "/communique/counsellings",
    EVENTS: "/communique/events",
  },
  feedback: {
    SUBMIT_FEEDBACK: "/feedback/record",
  },
  userReport: {
    SUBMIT_REPORT: "/user_reports/report",
    FILTER_DATA: "/user_reports/filter_data",
  },
  package: {
    GET_EXAM_LIST: "/packages/exams",
    GET_PACKAGE_LIST: "/packages/list",
    PURCHASE: "/packages/purchase",
    VALIDATE_DISCOUNT_CODE: "/packages/validate_discount_code",
    UPDATE_TXN: "/packages/update_txn",
    SUMMARY: "/packages/summary",
  },
  predictor: {
    GET_FORM_OPTIONS: `${openUrl}/neet_ug/predictor/form_options`,
    GET_COUNSELLING: `${openUrl}/neet_ug/predictor/find_counsellings`,
    GET_FILTER_DATA: `${openUrl}/neet_ug/predictor/filter_data`,
    GET_ALL_PREDICTIONS: `${openUrl}/neet_ug/predictor/table_data`,
  },
  postsubscription: {
    announcements: {
      list: "/info/announcements",
      filterData: "/info/filter_data",
    },
    events: {
      list: "/info/events",
      filterData: "/info/events",
    },
    counsellings: {
      list: "/info/counselling_timeline",
      counsellings: "/info/counselling_timeline",
    },
  },
  transaction: {
    FETCH_TXN: "/txns",
  },
  faq: {
    categories: "/faqs/filter_data",
    list: "/faqs",
  },
  allotmentMapping: {
    allotmentMapping: "/allotments_mapping/map",
    filterdata: "/allotments_mapping/filter_data",
    counsellingRounds: "/allotments_mapping/counselling_rounds",
    sessions: "/allotments_mapping/sessions",
  },
  seatMatrix: {
    GET_COUNSELLING_LIST: "/seat_matrices/counsellings",
    GET_FILTER_DATA: "/seat_matrices/filter_data",
    GET_SEAT_MATRIX_LIST: "/seat_matrices/table_data",
  },
  resources: {
    data: "/resources",
    filter: "/resources/filter_data",
  },
  institutes: {
    list: "/institutes",
    filterdata: "/institutes/filter_data",
    details: "/institutes",
  },
  courses: {
    list: "/courses",
    filterdata: "/courses/filter_data",
  },
  quotas: {
    list: "/quotas/table_data",
    show: "/quotas",
  },
  counsellings: {
    list: "/counsellings",
    details: "/counsellings",
    filterdata: "/counsellings/filter_data",
  },
  universities: {
    list: "/universities",
    details: "/universities",
    filterdata: "/universities/filter_data",
  },
  rankscan: {
    list: "/rank_scan/table_data",
    filter: "/rank_scan/filter_data",
  },
  fee: {
    list: "/fees/table_data",
    filter: "/fees/filter_data",
    details: "/fees",
    instituteFilterData: "/fees/institute_filter_data",
    instituteTableData: "/fees/institute_table_data",
  },
  choiceList: {
    choicelist: "/choice_lists_v2/table_data",
    filter: "/choice_lists_v2/filter_data",
    createChoicelist: "/choice_lists_v2",
    choicelistTable: "/choice_lists_v2",
    counsellings: "/choice_lists_v2/new",
  },
  choices: {
    counsellings: "/choices/counsellings",
    choicespopup: "/choices_v2/new",
    add: "/choices_v2",
    membership: "/choices_v2/choice_membership",
    filter: "/choices_v2/filter_data",
    choicesTable: "/choices_v2/table_data",
    download: "/choices_v2/download",
  },
  seatIncrease: {
    tableData: "/seat_differences/table_data",
    filterData: "/seat_differences/filter_data",
  },
  referral: {
    details: "/referral/details",
    rewards: "/referral/rewards",
    withdrawal_list: "/referral/withdrawals",
    validate_payment: "/referral/validate_payment",
    initiate_payment: "/referral/initiate_payment",
  },
  videos: {
    baseVideoUrl: `/videos/`,
    filter_data: "/videos/filter_data",
    gallery_list: "/videos/gallery_list",
    categorised_list: "/videos/categorised_list",
    related_videos: `/related_videos`,
    saveVideo: "/videos/",
    snapshot: "/videos/snapshot",
  },
  spottedErrors: {
    filterData: "/user_data_reports/filter_data",
    report: "/user_data_reports/report",
  },
};

export const publicEndPoints = {
  package: { GET_EXAM_LIST: "/public/packages/exams", GET_PACKAGE_LIST: "/public/packages" },
  exam: {
    GET_VIDEOS: `/public/videos`,
    GET_FEATURES: `/public/exams/features`,
  },
  institutes: {
    baseUrl: "/public/institutes",
    filterdata: "/public/institutes/filter_data",
  },
  influencerProgram: {
    DISCOUNT_REWARD: "/transactions/discount_rewards",
  },
  blogs: {
    baseUrl: "/public/blogs",
    filterData: "/public/blogs/filter_data",
  },
  videos: {
    baseVideoUrl: "/public/videos",
    exams: "/public/videos/exams",
    categorised_list: "/public/videos/categorised_list",
    gallery_list: "/public/videos/gallery_list",
    filter_data: "/public/videos/filter_data",
    related_videos: "/related_videos",
  },
  neetlyEvent: {
    register: "/public/ems_events",
    validate_discount_code: "/public/ems_events/validate_discount_code",
    registrationSummary: "/public/ems_events/registration_summary",
    initiate_payment: "/public/ems_events/pay",
    fetch_txn: "/public/ems_events/fetch_txn_details",
  },
};
